// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"b3debe79","787":"eb6bacdc"}[chunkId] + ".chunk.js";
};